import { ProgramWizardConfig } from './types';
import { getAscendQuestWebQuestProgramWizardConfig } from '@/app/features/products';
import { getAscendArchivestSelfServeArchivesProgramWizardConfig } from '@/app/features/products/archives';
import { getAscendUSAAProgramWizardConfig } from '@/app/features/products/usaa/utils';
import { match } from 'ts-pattern';
import { PackageNameEnum, ProductNameEnum } from '@ssar-app/domain';

export const getProgramWizardConfigForProductAndPackage = async (
  productName: string,
  packageName: string,
): Promise<ProgramWizardConfig> => {
  const toReturn = match([productName, packageName])
    .with(
      [ProductNameEnum.AscendQuest, PackageNameEnum.WebQuest],
      async (_) => {
        const config = await getAscendQuestWebQuestProgramWizardConfig();
        return config;
      },
    )
    .with(
      [ProductNameEnum.AscendArchives, PackageNameEnum.FrontEndProcessing],
      async (_) => {
        const config =
          await getAscendArchivestSelfServeArchivesProgramWizardConfig();
        return config;
      },
    )
    .with([ProductNameEnum.AscendUSAA, ''], async (_) => {
      const config = await getAscendUSAAProgramWizardConfig();
      return config;
    })
    .otherwise(([productName, packageName]) => {
      throw Error(
        `Could not find wizard config for the product: ${productName} and package: ${packageName}`,
      );
    });
  return toReturn;
};
